export default __webpack_public_path__ + "static/media/stamp5.6ac5ab3c.png";